
<template>
  <div class="pb-1 mb-2">
    <div
      class="d-flex align-items-center title-background ps-2 py-1 mouse-hover"
      @click="togleDisplay(reference)"
    >
      <div class="ps-1" />
      <RuleCaret
        v-model="displayDetails"
      />
      <div
        class="fw-bold ps-2 flex-grow-1"
        v-safe-html="trans(`subscription.classification_config.selectors.not.not`)"
      />
    </div>
    <div
      v-if="displayDetails"
      class="fw-bold my-1 ms-3"
    >
      {{ trans(`subscription.classification_config.selector_type`) }}
    </div>
    <div v-if="displayDetails">
      <SelectorSelect
        v-model="model.type"
        class="mx-3"
        @change="applyTypeChange"
      />
    </div>
    <SelectorTypeShow
      :selector="selector.selector"
      :display-delete="false"
    />
  </div>
</template>

<script>
import selectorMixin from '@/employees/components/Selector/utilities/mixins/selectorMixin'
import { SELECTOR_TYPE } from '@/constants'
import _cloneDeep from 'lodash/cloneDeep'
import { mapState } from 'vuex'
export default {
  name: 'SelectorNot',
  mixins: [selectorMixin],
  props: {
    reference: {
      required: true,
      type: String,
    },
    selector: {
      required: true,
      type: Object,
    },
  },
  data () {
    return {
      model: _cloneDeep(this.selector.selector),
    }
  },
  computed: {
    ...mapState({
      displayDetails (state) {
        return state.selectors.displaySelector[this.reference]
      },
    }),
  },
  methods: {
    applyTypeChange (selectorEnum) {
      if (Object.values(SELECTOR_TYPE).includes(selectorEnum)) {
        this.searchParentAddChild(this.selector.selector.reference, selectorEnum, SELECTOR_TYPE.not)
        this.hideDisplay(this.reference)
      }
    },
  },
}
</script>

<style  scoped>
.title-background {
  background-color: rgba(0, 0, 0, 0.2);
}
.condition-border {
  border-left-style: dotted;
  border-color: gray;
  border-width: 2px;
}
.mouse-hover {
  cursor: pointer
}
</style>
